// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"487":"receiving","554":"debtors","970":"payments"}[chunkId] + "." + {"487":"f91e4d57","554":"3072a3c7","970":"5e6642f9"}[chunkId] + ".js";
};